module.exports = __webpack_public_path__ + "assets/hero--background.6ab4f097.svg";